import { Component, OnInit } from '@angular/core';
import { BPProfilesService, BPProfilesViewCode } from '../../bp-profiles.service';
import { AuthService } from '../../../../shared/services/auth/auth.service';
import { STATE_BPPROFILES_INVOICEDETAIL } from '../../../../shared/app-states';

@Component({
  selector: 'bp-profiles-invoice-overview',
  template: `
    <invoice-templates
      [companyCountryId]="companyCountryId"
      [writeSupport]="hasWritePermission"
      detailState="${STATE_BPPROFILES_INVOICEDETAIL}"
    ></invoice-templates>
  `
})
export class BPProfilesInvoiceOverviewComponent implements OnInit {
  public hasWritePermission:boolean;
  public companyCountryId:number;

  constructor(
    private bpProfilesService:BPProfilesService,
    private authService:AuthService
  ) {
    /**/
  }

  public ngOnInit():void {
    this.companyCountryId = this.bpProfilesService.activeProfile?.companyCountryId;
    this.hasWritePermission = this.authService.viewWrite(BPProfilesViewCode.INVOICE);
  }
}